import React from 'react';
import LinkIcon from '@material-ui/icons/Link';
import AttachIcon from '@material-ui/icons/Attachment';
import ShareIcon from '@material-ui/icons/Share';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import BookmarkIcon from '@material-ui/icons/Bookmark';

const MediaIcon = ({ type, sourceType, ...restProps }) => {
  switch (type) {
    case 'embed':
      return <ShareIcon {...restProps} />;
    case 'file':
      switch (sourceType) {
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/svg+xml':
          return <InsertPhotoIcon {...restProps} />;
        case 'application/pdf':
          return <PictureAsPdfIcon {...restProps} />;
        default:
          return <AttachIcon {...restProps} />;
      }
    case 'page-link':
      return <BookmarkIcon {...restProps} />;
    default:
      return <LinkIcon {...restProps} />;
  }
};

export default MediaIcon;
